import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useErrorMessage } from '#error-message/useErrorMessage';

import type { QuizEditMarkedData } from './quizService';

import { QuizKey } from './keys';
import { QuizService } from './quizService';

export function useEditMarkedQuiz() {
  const queryClient = useQueryClient();
  const editMarkedQuiz = useMutation({
    mutationFn: ({ id, attemptId, ...data }: QuizEditMarkedData & { id: string; attemptId: string }) => QuizService.editMarkedQuiz(data, id, attemptId).then((response) => response.data),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: [QuizKey.QUIZ, variables.id, variables.attemptId],
      });
    },
  });

  const errorMessage = useErrorMessage(editMarkedQuiz.error);

  return { ...editMarkedQuiz, errorMessage };
}
